/**
 * Refactored Register Asset Page - Phase 4 Implementation
 *
 * Clean, modular replacement for the 7,482-line monolithic registration system.
 * Uses the new registration architecture with context, hooks, and wizard components.
 */

import { Box } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { RegistrationWizard } from '../modules/registration/components/RegistrationWizard';
import { RegistrationProvider } from '../modules/registration/contexts/RegistrationContext';

function getCreatedAssetId(createdAsset: any): string {
  return createdAsset?.id != null ? String(createdAsset.id).trim() : '';
}

const RefactoredRegisterAssetPage: React.FC = () => {
  const navigate = useNavigate();

  const handleRegistrationComplete = (createdAsset: any) => {
    const assetId = getCreatedAssetId(createdAsset);
    if (assetId) {
      navigate(`/assets/${assetId}`);
    } else {
      console.warn('Registration complete but no asset ID in response. Could not open asset details.', createdAsset);
      // Do not redirect to search-assets; user stays on success screen and can use "Create Another" or navigate manually.
    }
  };

  const handleRegistrationCancel = () => {
    // Navigate back to Browse
    navigate('/search-assets');
  };

  return (
    <RegistrationProvider>
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          bgcolor: 'background.default',
        }}
      >
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          }}
        >
          <RegistrationWizard
            onComplete={handleRegistrationComplete}
            onCancel={handleRegistrationCancel}
            onRegisterAnother={() => navigate('/register-asset')}
          />
        </Box>
      </Box>
    </RegistrationProvider>
  );
};

export default RefactoredRegisterAssetPage;
